/**
 * The campaign / firm cases page has two modes, chosen by the size of its (campaign, org)
 * slice:
 *
 *   - At or under ORG_DETAIL_SERVER_PAGING_THRESHOLD cases: the FULL LOAD. GET
 *     /campaigns/:campaignId/organizations/:organizationId (no `page`) returns every case,
 *     and the browser searches, sorts, filters and exports on every column — fuzzy search,
 *     encrypted PII and custom text fields included.
 *   - Over it: SERVER PAGING (`?page=`, backend lib/campaigns/org-detail-paging.ts). One page
 *     at a time; the server can only sort / filter / search plaintext columns (and match
 *     hashed names, emails and phones exactly). The page offers to preload every case through
 *     the same paged endpoint, after which the browser takes over as in the small mode.
 *
 * The full load materializes the whole slice (on prod a 139k-case slice took ~57s and 2-3 GB of
 * API heap, then failed), so above the threshold it refuses, up front, with a 422 carrying
 * ORG_CAMPAIGN_DETAIL_TOO_LARGE. The page never asks for it there.
 */
export const ORG_DETAIL_SERVER_PAGING_THRESHOLD = 5_000;

/** The full load's limit: the same number, so the full load never runs on a paged-size slice. */
export const MAX_ORG_CAMPAIGN_DETAIL_CASES = ORG_DETAIL_SERVER_PAGING_THRESHOLD;

/** The `code` on the route's 422 body when the slice is over the limit. */
export const ORG_CAMPAIGN_DETAIL_TOO_LARGE = "ORG_CAMPAIGN_DETAIL_TOO_LARGE";
